var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-icon-button',{staticStyle:{"font-size":"24px"},attrs:{"disabled":_vm.disabled,"name":_vm.ICON_NAMES.NEXT_BUTTON},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }